import { useState, useEffect, useContext, useCallback } from 'react';
import firebase from '../../api/firebase/index';
import { SetUserContext, UserContext } from 'routes/login/userContext';
import { getUserVerification } from 'api/login';
import { useLogout } from './useLogout';
import useDSSNotification from 'hooks/useDSSNotification';

const auth = firebase.auth();
const appsLength = firebase.apps.length;

export function useVerifyUser() {
  const [isVerifying, setIsVerifying] = useState<boolean>(true);
  const userContext = useContext(UserContext);
  const setUserContext = useContext(SetUserContext);
  const { logout } = useLogout();
  const { notifyError } = useDSSNotification();
  const showLoginError = useCallback(async () => {
    const loginNotificationPromise = new Promise((resolve) => {
      notifyError({
        message: '登入失敗',
      });
      setTimeout(() => {
        resolve('');
      }, 500);
    });

    return loginNotificationPromise;
  }, [notifyError]);

  useEffect(() => {
    const unregisterAuthObserver = appsLength
      ? auth.onAuthStateChanged(async () => {
          setIsVerifying(true);
          try {
            const response = await getUserVerification();
            const { firebaseUser, supplier_id, role, id } = response;
            if (!(firebaseUser && id)) {
              throw Error('Auth Failed');
            }
            setUserContext({
              role,
              id,
              supplier_id: supplier_id,
              firebaseUser,
            });
            setIsVerifying(false);
            return firebaseUser;
          } catch (error) {
            console.error(error);
            await showLoginError();
            await logout();
          }
        })
      : () => {};
    return unregisterAuthObserver;
  }, [logout, setUserContext, showLoginError]);

  return {
    isVerifying,
    user: userContext,
  };
}

export default useVerifyUser;
